import {React} from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import {motion} from 'framer-motion'
import { Link } from 'react-router-dom'
import ProductTimer from '../assets/images/counter-timer-img.webp'
import Clock from '../components/UI/Clock'

const TimerCount = () => {
    return (
        <section className='timer__count'>
            <Container>
            <Row>
                <Col lg='6' md='12' className='count__down-col'>
                    <div className="clock__top-content">
                        <h4 className='text-white fs-6 mb-2'>Limited Offers</h4>
                        <h3 className='text-white fs-5 mb-3'>Quality Armchair</h3>
                    </div>
                    <Clock/>
                    <motion.button whileHover={{scale:1.1}} className="buy__btn store__btn">
                        <Link to='/shop'>Visit Store</Link>
                    </motion.button>
                </Col>
                <Col className='text-end counter__img' lg='6' md='12'>
                    <img src={ProductTimer} alt="product" />
                </Col>
            </Row>
            </Container>
        </section>
    )
}

export default TimerCount